import type { HTMLAttributes } from "react";

import {
  TEXT_SECTION_LABEL,
  TEXT_SECTION_LABEL_MENU,
  TEXT_SECTION_LABEL_SIDEBAR,
} from "@/lib/surface-styles";
import { cn } from "@/lib/utils";

type SectionLabelVariant = "sidebar" | "page" | "menu";

const VARIANT_CLASSES: Record<SectionLabelVariant, string> = {
  sidebar: TEXT_SECTION_LABEL_SIDEBAR,
  page: TEXT_SECTION_LABEL,
  menu: TEXT_SECTION_LABEL_MENU,
};

type SectionLabelProps = HTMLAttributes<HTMLSpanElement> & {
  variant?: SectionLabelVariant;
};

/** Uppercase section heading — sidebar toggles, page groups, menu subsections. */
export function SectionLabel({
  variant = "page",
  className,
  ...props
}: SectionLabelProps) {
  return (
    <span className={cn(VARIANT_CLASSES[variant], className)} {...props} />
  );
}
